import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OpenInNewTabDirective } from './open-in-new-tab.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [OpenInNewTabDirective],
  exports: [OpenInNewTabDirective],
})
export class OpenInNewTabModule {}
